var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwapper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button/swap/default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C13.64,0 15.19,0.315 16.65,0.945 C18.11,1.575 19.385,2.435 20.475,3.525 C21.565,4.615 22.425,5.89 23.055,7.35 C23.685,8.81 24,10.36 24,12 C24,13.64 23.685,15.19 23.055,16.65 C22.425,18.11 21.565,19.385 20.475,20.475 C19.385,21.565 18.11,22.425 16.65,23.055 C15.19,23.685 13.64,24 12,24 C10.36,24 8.81,23.685 7.35,23.055 C5.89,22.425 4.615,21.565 3.525,20.475 C2.435,19.385 1.575,18.11 0.945,16.65 C0.315,15.19 0,13.64 0,12 C0,10.36 0.315,8.81 0.945,7.35 C1.575,5.89 2.435,4.615 3.525,3.525 C4.615,2.435 5.89,1.575 7.35,0.945 C8.81,0.315 10.36,0 12,0 Z M8.655,10.41 C8.405,10.41 8.19,10.5 8.01,10.68 L4.56,14.1 C4.38,14.28 4.29,14.49 4.29,14.73 C4.29,14.97 4.38,15.18 4.56,15.36 L8.01,18.81 C8.17,18.97 8.38,19.05 8.64,19.05 C8.9,19.05 9.12,18.96 9.3,18.78 C9.48,18.6 9.57,18.385 9.57,18.135 C9.57,17.885 9.48,17.67 9.3,17.49 L7.41,15.63 L12.33,15.63 C12.57,15.63 12.775,15.545 12.945,15.375 C13.115,15.205 13.2,14.99 13.2,14.73 C13.2,14.47 13.115,14.255 12.945,14.085 C12.775,13.915 12.56,13.83 12.3,13.83 L7.41,13.83 L9.3,11.94 C9.46,11.78 9.545,11.575 9.555,11.325 C9.565,11.075 9.48,10.86 9.3,10.68 C9.12,10.5 8.905,10.41 8.655,10.41 Z M15.375,5.16 C15.125,5.16 14.91,5.25 14.73,5.43 C14.55,5.61 14.46,5.83 14.46,6.09 C14.46,6.35 14.55,6.57 14.73,6.75 L16.59,8.61 L11.67,8.61 C11.43,8.61 11.225,8.7 11.055,8.88 C10.885,9.06 10.8,9.27 10.8,9.51 C10.8,9.77 10.885,9.985 11.055,10.155 C11.225,10.325 11.44,10.41 11.7,10.41 L16.59,10.41 L14.7,12.3 C14.52,12.48 14.435,12.69 14.445,12.93 C14.455,13.17 14.55,13.38 14.73,13.56 C14.91,13.74 15.125,13.83 15.375,13.83 C15.625,13.83 15.84,13.74 16.02,13.56 L19.44,10.14 C19.62,9.96 19.71,9.75 19.71,9.51 C19.71,9.27 19.62,9.06 19.44,8.88 L16.02,5.43 C15.84,5.25 15.625,5.16 15.375,5.16 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button/swap/default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/swap",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Neutral-Fill",
    mask: "url(#mask-2)",
    fill: "#A3AFB7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    id: "Fill"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapper);
export default __webpack_public_path__ + "static/media/swapper.ba5042ae9a3c166e64c3bcba8aed7737.svg";
export { ForwardRef as ReactComponent };